import {BaseDao} from "./BaseDao";
import {ApiHelper} from "../apiHelper";
import {ConstantMan} from "../constantMan";
import { Observable } from 'rxjs';

export class FormatBroadcasterFilterDao extends BaseDao {
  constructor(apiHelper: ApiHelper) {
    super(ConstantMan.API.RESOURCE.FORMAT_BROADCASTER_FILTERS, apiHelper);
  }

  getAllForFormat(formatId: number): Observable<any> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/find/' + formatId;
    return this.apiHelper.get(url, null, null);
  }
}
